import { WDD } from '../core/wdd.js';

export function legalOpenner() {
    const legalOpeners = WDD.el.querySelectorAll('.js-legal-opener');
    
    legalOpeners.forEach(opener => {
        opener.addEventListener('click', (e) => {
            e.preventDefault();
            
            WDD.el.querySelector('.bp-legal--hidden')?.classList.remove('bp-legal--hidden');
            
            const target = WDD.el.querySelector(e.target.closest("a")?.hash);
            if (target) {
                const top = target.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        });
    });
}